
export const APP_MODE = process.env.REACT_APP_MODE || 'user';
